const Select = {
  variants: {
    outline: {
      field: { borderColor: "gray.500", _placeholder: { color: "dark.200" } },
    },
  },
};

export default Select;
